import React from "react";
import { ReactController } from "../react_controller";
import { GregPrimerTheme, TreeGrid } from "@getregistered/greg-editors";
import { toastManager } from "../../components/DownloadTray/ToastManager";

export class PermissionsGridController extends ReactController {
  connect() {
    const { groups, roles, saveUrl, readOnly, matrix, cleanMessage, dirtyMessage } = this.propsValue;

    const handleSave = async (_roleId, permissions) => {
      if (!saveUrl) return permissions;
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
      const response = await fetch(saveUrl, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({ permissions }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || "Failed to save permissions");
      }
      toastManager.show({
        message: "Permissions saved successfully",
        variant: "success",
        icon: "check",
        autoCloseMs: 3000,
      });
      return Array.isArray(data.permissions) ? data.permissions : permissions;
    };

    this.root.render(
      <GregPrimerTheme>
        <TreeGrid
          groups={groups}
          roles={roles}
          onSave={handleSave}
          readOnly={readOnly}
          matrix={matrix}
          cleanMessage={cleanMessage}
          dirtyMessage={dirtyMessage}
        />
      </GregPrimerTheme>
    );
  }
}
